import type { ZapiPath } from '@weft/zapi-types';
import { PATH_ACCESS_LEVELS } from '@weft/zapi-types';
import { NEST_API_TAGS } from '../../api-tags';
import { CUSTOMER_ID_PATH_PARAM } from '../../customer-paths';
import { INVOICE_ID_PATH_PARAM } from '../../invoices-paths/invoice-id-path';

export const GET_CUSTOMER_INVOICE_PAGE_DATA_PATH = {
  accessLevel: PATH_ACCESS_LEVELS.PRIVATE,
  route: '/pages/customers/{customerId}/invoice/{invoiceId}',
  tags: NEST_API_TAGS.PAGES,
  pathParams: {
    [INVOICE_ID_PATH_PARAM.name]: INVOICE_ID_PATH_PARAM,
    [CUSTOMER_ID_PATH_PARAM.name]: CUSTOMER_ID_PATH_PARAM,
  },
} satisfies ZapiPath;

export type GetCustomerInvoicePageDataPath = typeof GET_CUSTOMER_INVOICE_PAGE_DATA_PATH;